import React from "react";
import PropTypes from "prop-types";

import Icon from "components/Icon";

const StationRow = ({ color, title, handleDelete, id }) => {
    const backgroundColor = color && !color.includes("#") ? `#${color}` : color;

    return (
        <div className="station-row">
            <div className="station-marker" style={{ backgroundColor }} />
            <span>{title}</span>
            {handleDelete && <Icon onClick={() => handleDelete(id)} type="delete" />}
        </div>
    );
};

StationRow.defaultProps = {
    color: "white",
    title: "",
    id: null,
};

StationRow.propTypes = {
    color: PropTypes.string,
    title: PropTypes.string,
    handleDelete: PropTypes.func,
    id: PropTypes.number,
};

export default StationRow;
